<template>
  <div id="wrapper">
    <section-header
      :text="$t('media.prTitle')"
      :back-text="$t('media.prBackText')"
    />
    <div id="top"></div>
    <transition tag="div">
      <Loading v-if="data === null" />
      <div class="press-release-wrapper" v-if="data !== null">
        <PressReleaseList
          class="press-release-list"
          v-on:scrollToTop="scrollToTop"
          :items="data"
        />
        <PressReleaseDetails
          class="press-release-details"
          :selectedItem="selectedItem"
          v-if="selectedItem"
        />
        <PressReleaseCondensedView
          class="press-release-details"
          :items="data"
          v-on:scrollToTop="scrollToTop"
          v-if="!selectedItem"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import SectionHeader from "../SectionHeader";
import PressReleaseList from "./PressReleaseList";
import PressReleaseDetails from "./PressReleaseDetails";
import Loading from "../Loading";
import PressReleaseCondensedView from "./PressReleaseCondensedView";
import VueScrollTo from "vue-scrollto";

export default {
  name: "Press",
  components: {
    PressReleaseCondensedView,
    Loading,
    PressReleaseDetails,
    PressReleaseList,
    SectionHeader
  },
  data() {
    return {
      data: null,
      selectedItem: null
    };
  },
  methods: {
    handleResponse(response) {
      this.data = response.data;

      if (this.data && this.$route.params.subsection) {
        for (let i = 0, n = this.data.length; i < n; i++) {
          if (this.$route.params.subsection === this.data[i].slug) {
            this.selectedItem = this.data[i];
            break;
          }
        }
      }
    },
    scrollToTop() {
      VueScrollTo.scrollTo("#top", 500);
    }
  },
  watch: {
    $route(to) {
      for (let i = 0, n = this.data.length; i < n; i++) {
        if (this.data[i].slug === to.params.subsection) {
          this.selectedItem = this.data[i];
          break;
        }
      }
    }
  },
  mounted() {
    this.$http
      .get("press-release/")
      .then(response => this.handleResponse(response));
  }
};
</script>

<style scoped>
.press-release-wrapper {
  display: flex;
  flex-direction: row;
}

.press-release-list {
  width: 30vw;
}

.press-release-details {
  width: 70vw;
  padding-left: 80px;
}

@media (max-width: 767px) {
  .press-release-wrapper {
    flex-direction: column-reverse;
  }

  .press-release-list,
  .press-release-details {
    width: 100%;
    padding: 0 15px;
  }
}
</style>
